import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ProvedorSessao } from './lib/sessao'
import { App } from './App'
/* A ordem aqui não é estética.
   · tokens.css e dataviz.css ficam FORA de camada: variável não tem
     especificidade, e mantê-las fora garante que qualquer camada as
     enxergue. `dataviz.css` nunca foi importado — os --cl-viz-* estavam
     definidos e nunca carregados.
   · tailwind.css traz as camadas, o Tailwind, a ponte do shadcn e o
     base.css/ui.css dentro de `@layer legado`. Por isso base.css sai
     daqui: dentro da camada ele perde de propósito para o CSS de tela,
     que continua fora e continua vencendo. */
import '@clinica/shared/tokens.css'
import '@clinica/shared/dataviz.css'
import './estilo/tailwind.css'
import './componentes/grafico/grafico.css'

const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('elemento #raiz não encontrado')

createRoot(raiz).render(
  <StrictMode>
    <ProvedorSessao>
      <App />
    </ProvedorSessao>
  </StrictMode>,
)
